function stringMapFromArray(array) {
  const result = {};
  array.forEach(elem => {
    result[elem] = elem;
  });
  return result;
}

const actionTypes = [
  "GET_PROCESSES",
  "ADD_PROCESS",
  "GET_CONTRIBUTORS",
  "PROCESSES_LOADING",
  "PROCESSES_LOADING_FINISHED",
  "SELECT_ELEMENT",
  "SELECT_PROCESS",
  "SELECT_SUBMISSION",
  "ENTER_PASSWORD",
  "OPEN_APPROVAL_MODAL",
  "OPEN_PROCESS_MODAL",
  "OPEN_INFO_MODAL",
  "OPEN_REFERENCE_MODAL",
  "OPEN_CONTRIBUTOR_MODAL",
  "OPEN_COMMENT_MODAL",
  "OPEN_FAB",
  "CLOSE_APPROVAL_MODAL",
  "CLOSE_PROCESS_MODAL",
  "CLOSE_INFO_MODAL",
  "CLOSE_REFERENCE_MODAL",
  "CLOSE_CONTRIBUTOR_MODAL",
  "CLOSE_COMMENT_MODAL",
  "CLOSE_FAB",
  "GET_SUBMISSIONS",
  "GET_COMMENTS",
  "SUBMISSIONS_LOADING",
  "SHOW_SCROLL_ARROW",
  "HIDE_SCROLL_ARROW",
  "DELETE_COMMENT",
  "DISPLAY_ERROR",
  "HIDE_ERROR",
  "EXTEND_LIST",
  "SET_SEARCH_TERM",
  "SET_SEARCH_MODE",
  "CHANGE_SUBMISSION",
  "GET_VISITORS"
];

module.exports = stringMapFromArray(actionTypes);
